// extracted by mini-css-extract-plugin
export default {"noImage":"noImage_noImage__3BXzC"};